// extracted by mini-css-extract-plugin
export default {"calc-body":"CalculatorBody_calc-body__zCZNb"};